import { AdresseList } from '@mairistem/adresses';

import type { AdresseType } from '@/types';

interface PayeurAdresseListItemProps {
  adresse: AdresseType;
}

const PayeurAdresseListItem = (props: PayeurAdresseListItemProps) => {
  const { adresse } = props;

  // AdresseList.Item ne masque que 0 : un numéro absent (null) s'afficherait « null »
  return <AdresseList.Item adresse={{ ...adresse, numeroVoirie: adresse?.numeroVoirie ?? 0 }} />;
};

export default PayeurAdresseListItem;
